import { Col, DatePicker, Form, Input, Radio } from 'antd'
import { FormInstance } from 'antd/lib'

import { requiredRules } from 'src/app-constants'
import {
  dayMonthYearHourMinutesFormatWithDot,
  disabledFutureDate
} from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
  /** Conformity the specimen already carries, so an edit that leaves a
   *  non-conform specimen untouched does not force a new reason. */
  initialIsConform?: boolean
}

/** Reception block shared by the create / edit external result modals: when the
 *  sample reached the laboratory and whether it was conform. These live on the
 *  specimen behind the result, not on the result itself. */
export const ExternalResultReceptionFields = ({
  form,
  initialIsConform
}: Props) => {
  const { t } = useLocales()

  const isConform = Form.useWatch('isConform', form)

  const isCommentRequired = isConform === false && initialIsConform !== false

  return (
    <>
      <Col span={12}>
        <Form.Item
          name="receivedAt"
          label={t('persons.external_result.received_at')}
          rules={requiredRules}
        >
          <DatePicker
            className="full-width"
            showTime
            showSecond={false}
            disabledDate={disabledFutureDate}
            format={dayMonthYearHourMinutesFormatWithDot}
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          name="isConform"
          label={t('persons.external_result.conformity')}
          rules={requiredRules}
        >
          <Radio.Group>
            <Radio value={true}>{t('common.yes')}</Radio>
            <Radio value={false}>{t('common.no')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {isConform === false && (
        <Col span={24}>
          <Form.Item
            name="nonConformityComment"
            label={t('persons.external_result.non_conformity_reason')}
            rules={isCommentRequired ? requiredRules : undefined}
          >
            <Input.TextArea
              rows={3}
              maxLength={500}
              showCount
              placeholder={t('persons.external_result.non_conformity_reason')}
            />
          </Form.Item>
        </Col>
      )}
    </>
  )
}
